module.exports = __webpack_public_path__ + "img/AH.20924e83.svg";